// extracted by mini-css-extract-plugin
export default {"option":"PXtToJwGJAoqqkCIojgr","arrow_icon":"Z0cx8gwLRrZfo7z9I9JR","option_label":"CWB3YmHkHpI_zCwgBHFS"};